import React from 'react'
import { Button, Table, Pagination } from 'semantic-ui-react'
import {getStatus} from "../misc/Helpers";

function UserTripTable({ usertrips, handleDeleteUserTrip, handleUserTripPaginationChange }) {
  let usertripList
  let activePage
  let totalPages
  if (!usertrips) {
    usertripList = (
      <Table.Row key='no-user'>
        <Table.Cell collapsing textAlign='center' colSpan='6'>Нет заявок</Table.Cell>
      </Table.Row>
    )
  } else {
    activePage = usertrips.number
    totalPages = usertrips.totalPages
    usertripList = usertrips.content.map(usertrip => {
      return (
        <Table.Row key={usertrip.id}>
          <Table.Cell collapsing>
            <Button
              circular
              color='red'
              size='small'
              icon='trash'
              onClick={() => handleDeleteUserTrip(usertrip.id)}
            />
          </Table.Cell>
          <Table.Cell>{usertrip.id}</Table.Cell>
          <Table.Cell>{usertrip.trip.id}</Table.Cell>
          <Table.Cell>{usertrip.trip.driver.name}</Table.Cell>
          <Table.Cell>{new Date(usertrip.applyTime).toLocaleString('ru',
            { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })}</Table.Cell>
          <Table.Cell>{usertrip.user.name}</Table.Cell>
          <Table.Cell>{usertrip.user.phone}</Table.Cell>
          <Table.Cell>{getStatus(usertrip.status)}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <>
      <Table compact striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}/>
            <Table.HeaderCell width={1}>ID</Table.HeaderCell>
            <Table.HeaderCell width={2}>Trip ID</Table.HeaderCell>
            <Table.HeaderCell width={2}>Водитель</Table.HeaderCell>
            <Table.HeaderCell width={3}>Дата</Table.HeaderCell>
            <Table.HeaderCell width={2}>Пассажир</Table.HeaderCell>
            <Table.HeaderCell width={2}>Телефон</Table.HeaderCell>
            <Table.HeaderCell width={2}>Статус</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {usertripList}
        </Table.Body>
      </Table>
      <Pagination
        activePage={activePage+1}
        boundaryRange={1}
        onPageChange={handleUserTripPaginationChange}
        size='mini'
        totalPages={totalPages}
      />
    </>
  )
}

export default UserTripTable
